export {
  getCompletedFormDisplayLabel,
  getPolicyStreamFormLabel,
  getPolicyStreamFormLabelFromInternalName,
} from '../../../util/completedFormDisplayLabel';

interface WithInternalName {
  internalName?: string;
}
export const sortByInternalName = (
  a: WithInternalName,
  b: WithInternalName,
): number => {
  if (!a.internalName && b.internalName) {
    return -1;
  } else if (a.internalName && !b.internalName) {
    return 1;
  } else if (!a.internalName && !b.internalName) {
    return 0;
  }
  const priorityA = getInternalNamePriority(a.internalName);
  const priorityB = getInternalNamePriority(b.internalName);
  return priorityA - priorityB;
};

/**
 * Utility function for sorting by internal name
 */
const getInternalNamePriority = (internalName: string | undefined) => {
  // TODO this is brittle - we should use the form internal names in POLICYSTREAM_FORMS
  const INTERNAL_NAME_REGEXES = [
    /^basic_info/i,
    /^basic_client_info/i,
    /^needs_analysis/i,
    /^application_.+/i,
  ];
  if (!internalName) {
    return INTERNAL_NAME_REGEXES.length;
  }
  let foundIndex = INTERNAL_NAME_REGEXES.findIndex((regex) =>
    regex.test(internalName),
  );
  foundIndex = foundIndex === -1 ? INTERNAL_NAME_REGEXES.length : foundIndex;

  return foundIndex;
};
